/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
import React from 'react';
import { graphql } from 'gatsby';
import { NewGLULayout } from '../../layouts/new-glu-layout';
import NewGluCard from '../../components/glu/organisms/new-home-glu-cards';
// import { pickedForYouCourses } from '../../components/glu/atoms/new-glu-home-page/data';

const ViewAllPickedForYouCourses = ({ coursesData }) => (
	<div className="my-6 sm:p-10 md:p-5 lg:p-5 xl:p-5  grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-10  p-5 ">
		{coursesData &&
			coursesData.map((data, index) => (
				<NewGluCard key={index.id} data={data} compact={false} />
			))}
	</div>
);

const WrappedViewAllPickedForYouCourses = ({ data }) => {
	const nav = data?.datoCmsGluSiteSetting?.primaryHeader || [];
	const pickedForYou = data?.datoCmsGluHomepage?.pickedForYou || [];
	const weeklyWebinar = data?.datoCmsGluSiteSetting?.upcomingWebinar || [];
	return (
		<NewGLULayout nav={nav} weeklyWebinar={weeklyWebinar}>
			<h1 className="max-w-m-screen mx-auto mb-10 gluxs:mb-2 glu2xl:mb-10 glumd:mb-5 text-blue-500 text-center text-2xl gluxs:text-lg glu2xl:text-2xl glumd:text-2xl welcome-animation">
				<span className="pl-2 pr-2 bg-none">Picked For You</span>
			</h1>
			<ViewAllPickedForYouCourses coursesData={pickedForYou} />
		</NewGLULayout>
	);
};

export default WrappedViewAllPickedForYouCourses;
export const query = graphql`
	query ViewAllPickedForYouCourses($locale: String!) {
		datoCmsGluSiteSetting(locale: { eq: $locale }) {
			primaryHeader {
				title
				link
				icon {
					url
					alt
				}
				treeChildren {
					title
					subText
					link
					icon {
						url
						alt
					}
					position
					locale
				}
			}
			upcomingWebinar {
				title
				dateAndTime(formatString: "Do MMMM YYYY")
				startTime: dateAndTime
				slug
				timeEnd
			}
		}
		datoCmsGluHomepage(locale: { eq: $locale }) {
			pickedForYou {
				slug
				title
				timeToWatchInMinutes
				thumbnail {
					alt
					url
					gatsbyImageData(imgixParams: {}, layout: CONSTRAINED)
				}
				timeToWatchInMinutes
				moreCategory {
					title
					slug
				}
				category {
					title
					slug
				}
			}
		}
	}
`;
